import { PdfReplacement } from './ReceiptPdf.types';
import { CountriesISO2, PAPER_SIZE } from '../../types/enums';
import { ReceiptProps } from './ReceiptPDFA4';
import { getTranslations } from '../../translations';

export const getStringWithMultipleReplacements = (value: string, replacements: PdfReplacement[]): string => {
  if (!replacements.length) {
    return value;
  }
  return getStringWithMultipleReplacements(
    value.replaceAll(
      replacements[0].replaceable,
      replacements[0].replacement
    ),
    replacements.slice(1)
  );
};

export const getTaxTranslationsByCurrency = (currency: string, countryCodeISO2: CountriesISO2) => {
  const {gst, vat,defaultTax} = getTranslations().receipt.countrySpecific;
  if (currency === 'AUD') {
    return { exclTaxLabel: gst.exclTax, taxLabel: `${gst.tax} @10%` };
  }

  if (currency === 'GBP') {
    return { exclTaxLabel: vat.exclTax, taxLabel: `${vat.tax} @20%` };
  }

  if(currency === 'EUR') {
    if (countryCodeISO2 === CountriesISO2.DE) {
      return { exclTaxLabel: vat.exclTax, taxLabel: `${vat.tax} @19%` };
    }
    if (countryCodeISO2 === CountriesISO2.NL) {
      return { exclTaxLabel: vat.exclTax, taxLabel: `${vat.tax} @21%` };
    }
    //TODO handle SB
    // if (countryCodeISO2 === CountriesISO2.FR) {
    //   return { exclTaxLabel: vat.exclTax, taxLabel: `${vat.tax} @20%` };
    // }
    //TODO handle CB
    if (countryCodeISO2 === CountriesISO2.FR) {
      return { exclTaxLabel: vat.exclTax, taxLabel: vat.tax };
    }
    if (countryCodeISO2 === CountriesISO2.IT) {
      return { exclTaxLabel: vat.exclTax, taxLabel: `${vat.tax} @20%` };
    }
  }
  if (currency === 'JPY') {
    return { exclTaxLabel: defaultTax.exclTax, taxLabel: `${defaultTax.tax} @10%` };
  }

  return { exclTaxLabel: defaultTax.exclTax, taxLabel: defaultTax.tax };
};

export const getReceiptStyles = (paperSize: ReceiptProps['size'], isSignatureExpanded: boolean) => {
  if (paperSize === PAPER_SIZE.W105xH140mm) {
    return {
      event: {
        padding: '4px 0'
      },
      totalWrapper: {
        marginBottom: 0
      },
      signature: {
        container: {
          margin: 'auto 0 0 0',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
          alignItems: 'flex-end',
          border: 'none',
          padding: 0,
          alignSelf: 'flex-end'
        },
        line: {
          width: '55%',
          padding: 0
        },
        title: {
          fontSize: isSignatureExpanded ? '8px' : '10px',
          width: '45%',
          alignSelf: 'none'
        }
      },
      label: {
        fontSize: isSignatureExpanded ? '8px' : '10px'
      },
      subLabel: {
        fontSize: isSignatureExpanded ? '8px' : '10px'
      },
      paddings: {
        paddingTop: 0,
        paddingBottom: '5px'
      },
      margins: {
        marginTop: 0,
        marginBottom: 0
      }
    } as any;
  }

  return {
    event: {},
    totalWrapper: {},
    signature: {
      container: {},
      line: {},
      title: {}
    },
    label: {},
    subLabel: {},
    paddings: {},
    margins: {}
  };
};
